import jsUtils from '@appPath/helpers/js-utils.js';

globalThis.jsUtils = jsUtils;